import React from 'react';
import { Box, Card, Group, Skeleton, Stack, SimpleGrid } from '@mantine/core';
import { FEED_VIDEO_MEDIA_SX } from './feedCardTheme';

export interface SlopDiscoverCardSkeletonProps {
  count?: number;
}

/** Loading placeholder for one discover-feed Slop post card. */
export function SlopDiscoverCardSkeleton ({ count = 1 }: SlopDiscoverCardSkeletonProps) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <Card
          key={i}
          padding={0}
          radius="md"
          withBorder
          sx={{
            width: '100%',
            overflow: 'hidden',
            borderColor: 'var(--gs-border)',
            backgroundColor: 'var(--gs-bg-2)'
          }}
        >
          <Skeleton sx={FEED_VIDEO_MEDIA_SX} radius={0} />
          <Box p="md">
            <Group spacing="sm" noWrap>
              <Skeleton circle height={32} width={32} />
              <Stack spacing={6} style={{ flex: 1 }}>
                <Skeleton height={12} width="35%" />
                <Skeleton height={12} width="80%" />
                <Skeleton height={10} width="25%" />
              </Stack>
            </Group>
          </Box>
          <Group spacing="md" p="sm" sx={{ borderTop: '1px solid var(--gs-border)' }}>
            <Skeleton circle height={36} width={36} />
            <Skeleton circle height={36} width={36} />
            <Skeleton height={10} width={80} ml="auto" />
          </Group>
        </Card>
      ))}
    </>
  );
}

export interface SlopLibraryGridSkeletonProps {
  count?: number;
}

/** Loading placeholder for the Slop library grid (`SlopVideoCard`). */
export function SlopLibraryGridSkeleton ({ count = 6 }: SlopLibraryGridSkeletonProps) {
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
      {Array.from({ length: count }, (_, i) => (
        <Box
          key={i}
          sx={{
            border: '1px solid var(--gs-border)',
            borderRadius: 8,
            overflow: 'hidden',
            background: 'var(--gs-surface2)'
          }}
        >
          <Skeleton height={200} radius={0} />
          <Box p="md">
            <Skeleton height={14} width="70%" mb={8} />
            <Skeleton height={10} width="40%" />
          </Box>
        </Box>
      ))}
    </SimpleGrid>
  );
}
